import React from "react";
import { CSpinner } from "@coreui/react";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  API_BASE_URL,
  PAYMNET_CANCEL_URL,
  PG_BASE_URL_PAYMENT,
  PG_WT_CLIENT_CODE,
  apiCall,
} from "src/_apiConfig/apiCall";

export default function SubmitAdHocPayment() {
  const formRef = useRef(null);
  const [checksum, setchecksum] = useState("");
  const [pgpath, setpgpath] = useState("");
  const { id, ahpid, amount, latefees } = useParams();

  const encrypted_id = window.atob(id);
  const encrypted_ahpid = window.atob(ahpid);
  const encrypted_amount = window.atob(amount);
  const encrypted_latefees = window.atob(latefees);

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  useEffect(() => {
    setpgpath(`${PG_BASE_URL_PAYMENT}/ws/payment`);

    const getDetails = async () => {
      const header = new Headers();
      header.append("Content-Type", "application/json");
      header.append("Accept", "application/json");
      var sessionID = makeid(35);
      const decid = window.btoa(encrypted_id);

      const responseData = await apiCall(
        `LotDetails/AdHocPayment_Payment?sessionId=${sessionID}&lotId=${encrypted_id}&ahpId=${encrypted_ahpid}&amount=${encrypted_amount}&lateFees=${encrypted_latefees}&returnUrl=${API_BASE_URL}PaymentResponse/adhocpaymentresponse&cancelUrl=${PAYMNET_CANCEL_URL}?value=${decid} `,
        "GET",
        header,
        null
      );
      const jsonobjData = await responseData.json();

      console.log(jsonobjData);
      if (responseData.status === 200) {
        setchecksum(jsonobjData);
        formRef.current.submit();
      }
      // if (responseData.status === 200) {
      //   .then((res) => {
      //     console.log("SubmitAdHocPayment res : ", res);
      //     if (res.success) {
      //       //const jsonobjData = await responseData.json();

      //       //console.log(jsonobjData);
      //       //if (responseData.status === 200) {
      //       setchecksum(res.data.json());
      //       formRef.current.submit();
      //     }
      //   });
    };

    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      {id ? (
        <form method="post" ref={formRef} action={pgpath}>
          {/* <input type="hidden" name="walletClientCode" value="WT-1304" /> */}
          <input
            type="hidden"
            name="walletClientCode"
            value={PG_WT_CLIENT_CODE}
          />
          <input type="hidden" name="walletRequestMessage" value={checksum} />
        </form>
      ) : (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      )}
    </>
  );
}
